export const instituteArticlesData = [
  {
    id: 0,
    title: "main.institute.article_0.title",
    desc: "main.institute.article_0.desc",
    name: "whatIsNZT",
    revision: "v1",
    navigation: [
      {
        label: "main.institute.questions_navigation",
        anchor: "#questions",
      },
    ],
    questions: [
      {
        id: 0,
        text: "main.institute.article_0.questions.question_0.text",
        answerA: "main.institute.article_0.questions.question_0.answerA",
        answerB: "main.institute.article_0.questions.question_0.answerB",
        answerC: "main.institute.article_0.questions.question_0.answerC",
        answerD: "main.institute.article_0.questions.question_0.answerD",
        rightAnswer: "C",
        explanation:
          "main.institute.article_0.questions.question_0.explanation",
      },
      {
        id: 1,
        text: "main.institute.article_0.questions.question_1.text",
        answerA: "main.institute.article_0.questions.question_1.answerA",
        answerB: "main.institute.article_0.questions.question_1.answerB",
        answerC: "main.institute.article_0.questions.question_1.answerC",
        answerD: "main.institute.article_0.questions.question_1.answerD",
        rightAnswer: "D",
        explanation:
          "main.institute.article_0.questions.question_1.explanation",
      },
      {
        id: 2,
        text: "main.institute.article_0.questions.question_2.text",
        answerA: "main.institute.article_0.questions.question_2.answerA",
        answerB: "main.institute.article_0.questions.question_2.answerB",
        answerC: "main.institute.article_0.questions.question_2.answerC",
        answerD: "main.institute.article_0.questions.question_2.answerD",
        rightAnswer: "B",
        explanation:
          "main.institute.article_0.questions.question_2.explanation",
      },
    ],
  },
  {
    id: 1,
    title: "main.institute.article_1.title",
    desc: "main.institute.article_1.desc",
    name: "NZTCoreFunctions",
    revision: "v1",
    navigation: [
      {
        label: "main.institute.article_1.navigation.autoclicker",
        anchor: "#autoclicker",
      },
      {
        label: "main.institute.article_1.navigation.autoInsuranceWaiver",
        anchor: "#autoInsuranceWaiver",
      },
      {
        label: "main.institute.article_1.navigation.automation",
        anchor: "#automation",
      },
      {
        label: "main.institute.article_1.navigation.selectHelper",
        anchor: "#selectHelper",
      },
      { label: "main.institute.article_1.navigation.news", anchor: "#news" },
      {
        label: "main.institute.article_1.navigation.newInterface",
        anchor: "#newInterface",
      },
      {
        label: "main.institute.questions_navigation",
        anchor: "#questions",
      },
    ],
    questions: [
      {
        id: 0,
        text: "main.institute.article_1.questions.question_0.text",
        answerA: "main.institute.article_1.questions.question_0.answerA",
        answerB: "main.institute.article_1.questions.question_0.answerB",
        answerC: "main.institute.article_1.questions.question_0.answerC",
        answerD: "main.institute.article_1.questions.question_0.answerD",
        rightAnswer: "B",
        explanation:
          "main.institute.article_1.questions.question_0.explanation",
      },
      {
        id: 1,
        text: "main.institute.article_1.questions.question_1.text",
        answerA: "main.institute.article_1.questions.question_1.answerA",
        answerB: "main.institute.article_1.questions.question_1.answerB",
        answerC: "main.institute.article_1.questions.question_1.answerC",
        answerD: "main.institute.article_1.questions.question_1.answerD",
        rightAnswer: "D",
        explanation:
          "main.institute.article_1.questions.question_1.explanation",
      },
      {
        id: 2,
        text: "main.institute.article_1.questions.question_2.text",
        answerA: "main.institute.article_1.questions.question_2.answerA",
        answerB: "main.institute.article_1.questions.question_2.answerB",
        answerC: "main.institute.article_1.questions.question_2.answerC",
        answerD: "main.institute.article_1.questions.question_2.answerD",
        rightAnswer: "C",
        explanation:
          "main.institute.article_1.questions.question_2.explanation",
      },
      {
        id: 3,
        text: "main.institute.article_1.questions.question_3.text",
        answerA: "main.institute.article_1.questions.question_3.answerA",
        answerB: "main.institute.article_1.questions.question_3.answerB",
        answerC: "main.institute.article_1.questions.question_3.answerC",
        answerD: "main.institute.article_1.questions.question_3.answerD",
        rightAnswer: "C",
        explanation:
          "main.institute.article_1.questions.question_3.explanation",
      },
    ],
  },
  {
    id: 2,
    title: "main.institute.article_2.title",
    desc: "main.institute.article_2.desc",
    name: "fuelSystem",
    revision: "v1",
    navigation: [
      {
        anchor: "#columnDesc",
        label: "main.institute.article_2.navigation.columnDesc",
      },
      {
        anchor: "#howToCount",
        label: "main.institute.article_2.navigation.howToCount",
      },
      {
        anchor: "#advantage",
        label: "main.institute.article_2.navigation.advantage",
      },
      { anchor: "#news", label: "main.institute.article_2.navigation.news" },
      {
        label: "main.institute.questions_navigation",
        anchor: "#questions",
      },
    ],
    questions: [
      {
        id: 0,
        text: "main.institute.article_2.questions.question_0.text",
        answerA: "main.institute.article_2.questions.question_0.answerA",
        answerB: "main.institute.article_2.questions.question_0.answerB",
        answerC: "main.institute.article_2.questions.question_0.answerC",
        answerD: "main.institute.article_2.questions.question_0.answerD",
        rightAnswer: "C",
        explanation:
          "main.institute.article_2.questions.question_0.explanation",
      },
      {
        id: 1,
        text: "main.institute.article_2.questions.question_1.text",
        answerA: "main.institute.article_2.questions.question_1.answerA",
        answerB: "main.institute.article_2.questions.question_1.answerB",
        answerC: "main.institute.article_2.questions.question_1.answerC",
        answerD: "main.institute.article_2.questions.question_1.answerD",
        rightAnswer: "C",
        explanation:
          "main.institute.article_2.questions.question_1.explanation",
      },
      {
        id: 2,
        text: "main.institute.article_2.questions.question_2.text",
        answerA: "main.institute.article_2.questions.question_2.answerA",
        answerB: "main.institute.article_2.questions.question_2.answerB",
        answerC: "main.institute.article_2.questions.question_2.answerC",
        answerD: "main.institute.article_2.questions.question_2.answerD",
        rightAnswer: "C",
        explanation:
          "main.institute.article_2.questions.question_2.explanation",
      },
      {
        id: 3,
        text: "main.institute.article_2.questions.question_3.text",
        answerA: "main.institute.article_2.questions.question_3.answerA",
        answerB: "main.institute.article_2.questions.question_3.answerB",
        answerC: "main.institute.article_2.questions.question_3.answerC",
        answerD: "main.institute.article_2.questions.question_3.answerD",
        rightAnswer: "A",
        explanation:
          "main.institute.article_2.questions.question_3.explanation",
      },
    ],
  },
  {
    id: 3,
    title: "main.institute.article_3.title",
    desc: "main.institute.article_3.desc",
    name: "installationAndSetup",
    revision: "v1",
    navigation: [
      {
        label: "main.institute.article_3.navigation.choice",
        anchor: "#choice",
      },
      {
        label: "main.institute.article_3.navigation.emulator-why",
        anchor: "#emulator-why",
      },
      {
        label: "main.institute.article_3.navigation.smartphone-why",
        anchor: "#smartphone-why",
      },
      {
        label: "main.institute.article_3.navigation.client-emulator.main",
        anchor: "#client-emulator",
        children: [
          {
            label:
              "main.institute.article_3.navigation.client-emulator.requirements-emulator",
            anchor: "#requirements-emulator",
          },
          {
            label:
              "main.institute.article_3.navigation.client-emulator.ldplayer-emulator",
            anchor: "#ldplayer-emulator",
          },
          {
            label:
              "main.institute.article_3.navigation.client-emulator.settings-emulator",
            anchor: "#settings-emulator",
          },
          {
            label:
              "main.institute.article_3.navigation.client-emulator.problems-emulator",
            anchor: "#problems-emulator",
          },
          {
            label:
              "main.institute.article_3.navigation.client-emulator.safety-emulator",
            anchor: "#safety-emulator",
          },
          {
            label:
              "main.institute.article_3.navigation.client-emulator.middle-pc-emulator",
            anchor: "#middle-pc-emulator",
          },
          {
            label:
              "main.institute.article_3.navigation.client-emulator.nzt-emulator",
            anchor: "#nzt-emulator",
          },
          {
            label:
              "main.institute.article_3.navigation.client-emulator.vpn-gps-emulator",
            anchor: "#vpn-gps-emulator",
          },
          {
            label:
              "main.institute.article_3.navigation.client-emulator.vpn-setup-emulator",
            anchor: "#vpn-setup-emulator",
          },
          {
            label:
              "main.institute.article_3.navigation.client-emulator.room-emulator",
            anchor: "#room-emulator",
          },
          {
            label:
              "main.institute.article_3.navigation.client-emulator.launch-emulator",
            anchor: "#launch-emulator",
          },
        ],
      },
      {
        label: "main.institute.article_3.navigation.client-smartphone.main",
        anchor: "#client-smartphone",
        children: [
          {
            label:
              "main.institute.article_3.navigation.client-smartphone.requirements-smartphone",
            anchor: "#requirements-smartphone",
          },
          {
            label:
              "main.institute.article_3.navigation.client-smartphone.preparation-smartphone",
            anchor: "#preparation-smartphone",
          },
          {
            label:
              "main.institute.article_3.navigation.client-smartphone.start-smartphone",
            anchor: "#start-smartphone",
          },
          {
            label:
              "main.institute.article_3.navigation.client-smartphone.vpn-smartphone",
            anchor: "#vpn-smartphone",
          },
          {
            label:
              "main.institute.article_3.navigation.client-smartphone.integration-smartphone",
            anchor: "#integration-smartphone",
          },
          {
            label:
              "main.institute.article_3.navigation.client-smartphone.resolution-smartphone",
            anchor: "#resolution-smartphone",
          },
          {
            label:
              "main.institute.article_3.navigation.client-smartphone.room-smartphone",
            anchor: "#room-smartphone",
          },
        ],
      },
      { label: "main.institute.article_3.navigation.faq", anchor: "#faq" },
      {
        label: "main.institute.questions_navigation",
        anchor: "#questions",
      },
    ],
    questions: [
      {
        id: 0,
        text: "main.institute.article_3.questions.question_0.text",
        answerA: "main.institute.article_3.questions.question_0.answerA",
        answerB: "main.institute.article_3.questions.question_0.answerB",
        answerC: "main.institute.article_3.questions.question_0.answerC",
        answerD: "main.institute.article_3.questions.question_0.answerD",
        rightAnswer: "B",
        explanation:
          "main.institute.article_3.questions.question_0.explanation",
      },
      {
        id: 1,
        text: "main.institute.article_3.questions.question_1.text",
        answerA: "main.institute.article_3.questions.question_1.answerA",
        answerB: "main.institute.article_3.questions.question_1.answerB",
        answerC: "main.institute.article_3.questions.question_1.answerC",
        answerD: "main.institute.article_3.questions.question_1.answerD",
        rightAnswer: "C",
        explanation:
          "main.institute.article_3.questions.question_1.explanation",
      },
      {
        id: 2,
        text: "main.institute.article_3.questions.question_2.text",
        answerA: "main.institute.article_3.questions.question_2.answerA",
        answerB: "main.institute.article_3.questions.question_2.answerB",
        answerC: "main.institute.article_3.questions.question_2.answerC",
        answerD: "main.institute.article_3.questions.question_2.answerD",
        rightAnswer: "B",
        explanation:
          "main.institute.article_3.questions.question_2.explanation",
      },
      {
        id: 3,
        text: "main.institute.article_3.questions.question_3.text",
        answerA: "main.institute.article_3.questions.question_3.answerA",
        answerB: "main.institute.article_3.questions.question_3.answerB",
        answerC: "main.institute.article_3.questions.question_3.answerC",
        answerD: "main.institute.article_3.questions.question_3.answerD",
        rightAnswer: "B",
        explanation:
          "main.institute.article_3.questions.question_3.explanation",
      },
      {
        id: 4,
        text: "main.institute.article_3.questions.question_4.text",
        answerA: "main.institute.article_3.questions.question_4.answerA",
        answerB: "main.institute.article_3.questions.question_4.answerB",
        answerC: "main.institute.article_3.questions.question_4.answerC",
        answerD: "main.institute.article_3.questions.question_4.answerD",
        rightAnswer: "B",
        explanation:
          "main.institute.article_3.questions.question_4.explanation",
      },
      {
        id: 5,
        text: "main.institute.article_3.questions.question_5.text",
        answerA: "main.institute.article_3.questions.question_5.answerA",
        answerB: "main.institute.article_3.questions.question_5.answerB",
        answerC: "main.institute.article_3.questions.question_5.answerC",
        answerD: "main.institute.article_3.questions.question_5.answerD",
        rightAnswer: "A",
        explanation:
          "main.institute.article_3.questions.question_5.explanation",
      },
    ],
  },
  {
    id: 4,
    title: "main.institute.article_4.title",
    desc: "main.institute.article_4.desc",
    name: "agentSupport",
    revision: "v1",
    navigation: [
      {
        label: "main.institute.article_4.navigation.support.main",
        anchor: "#support",
        children: [
          {
            label:
              "main.institute.article_4.navigation.support.support_common_rules",
            anchor: "#support_common_rules",
          },
          {
            label:
              "main.institute.article_4.navigation.support.support_agent_rules",
            anchor: "#support_agent_rules",
          },
          {
            label:
              "main.institute.article_4.navigation.support.support_respect",
            anchor: "#support_respect",
          },
        ],
      },
      {
        label: "main.institute.article_4.navigation.templates.main",
        anchor: "#templates",
        children: [
          {
            label:
              "main.institute.article_4.navigation.templates.templates_fakeDevice",
            anchor: "#templates_fakeDevice",
          },
          {
            label:
              "main.institute.article_4.navigation.templates.templates_mtt",
            anchor: "#templates_mtt",
          },
          {
            label:
              "main.institute.article_4.navigation.templates.templates_chip_price",
            anchor: "#templates_chip_price",
          },
          {
            label:
              "main.institute.article_4.navigation.templates.templates_issue",
            anchor: "#templates_issue",
          },
          {
            label: "main.institute.article_4.navigation.templates.templates_qa",
            anchor: "#templates_qa",
          },
        ],
      },
      {
        label: "main.institute.article_4.navigation.admin.main",
        anchor: "#admin",
        children: [
          {
            label:
              "main.institute.article_4.navigation.admin.admin_upperButtons",
            anchor: "#admin_upperButtons",
          },
          {
            label: "main.institute.article_4.navigation.admin.admin_agent_info",
            anchor: "#admin_agent_info",
          },
          {
            label: "main.institute.article_4.navigation.admin.admin_stats",
            anchor: "#admin_stats",
          },
        ],
      },
      {
        label: "main.institute.article_4.navigation.managers.main",
        anchor: "#managers",
        children: [
          {
            label:
              "main.institute.article_4.navigation.managers.managers_communication_rules",
            anchor: "#managers_communication_rules",
          },
          {
            label:
              "main.institute.article_4.navigation.managers.managers_product_rules",
            anchor: "#managers_product_rules",
          },
          {
            label:
              "main.institute.article_4.navigation.managers.managers_agent_rules",
            anchor: "#managers_agent_rules",
          },
          {
            label:
              "main.institute.article_4.navigation.managers.managers_collaboration_principles",
            anchor: "#managers_collaboration_principles",
          },
        ],
      },
      {
        label: "main.institute.article_4.navigation.jinchouma",
        anchor: "#jinchouma",
      },
      {
        label: "main.institute.questions_navigation",
        anchor: "#questions",
      },
    ],
    questions: [
      {
        id: 0,
        text: "main.institute.article_4.questions.question_0.text",
        answerA: "main.institute.article_4.questions.question_0.answerA",
        answerB: "main.institute.article_4.questions.question_0.answerB",
        answerC: "main.institute.article_4.questions.question_0.answerC",
        answerD: "main.institute.article_4.questions.question_0.answerD",
        rightAnswer: "A",
        explanation:
          "main.institute.article_4.questions.question_0.explanation",
      },
      {
        id: 1,
        text: "main.institute.article_4.questions.question_1.text",
        answerA: "main.institute.article_4.questions.question_1.answerA",
        answerB: "main.institute.article_4.questions.question_1.answerB",
        answerC: "main.institute.article_4.questions.question_1.answerC",
        answerD: "main.institute.article_4.questions.question_1.answerD",
        rightAnswer: "B",
        explanation:
          "main.institute.article_4.questions.question_1.explanation",
      },
      {
        id: 2,
        text: "main.institute.article_4.questions.question_2.text",
        answerA: "main.institute.article_4.questions.question_2.answerA",
        answerB: "main.institute.article_4.questions.question_2.answerB",
        answerC: "main.institute.article_4.questions.question_2.answerC",
        answerD: "main.institute.article_4.questions.question_2.answerD",
        rightAnswer: "C",
        explanation:
          "main.institute.article_4.questions.question_2.explanation",
      },
      {
        id: 3,
        text: "main.institute.article_4.questions.question_3.text",
        answerA: "main.institute.article_4.questions.question_3.answerA",
        answerB: "main.institute.article_4.questions.question_3.answerB",
        answerC: "main.institute.article_4.questions.question_3.answerC",
        answerD: "main.institute.article_4.questions.question_3.answerD",
        rightAnswer: "A",
        explanation:
          "main.institute.article_4.questions.question_3.explanation",
      },
      {
        id: 4,
        text: "main.institute.article_4.questions.question_4.text",
        answerA: "main.institute.article_4.questions.question_4.answerA",
        answerB: "main.institute.article_4.questions.question_4.answerB",
        answerC: "main.institute.article_4.questions.question_4.answerC",
        answerD: "main.institute.article_4.questions.question_4.answerD",
        rightAnswer: "A",
        explanation:
          "main.institute.article_4.questions.question_4.explanation",
      },
      {
        id: 5,
        text: "main.institute.article_4.questions.question_5.text",
        answerA: "main.institute.article_4.questions.question_5.answerA",
        answerB: "main.institute.article_4.questions.question_5.answerB",
        answerC: "main.institute.article_4.questions.question_5.answerC",
        answerD: "main.institute.article_4.questions.question_5.answerD",
        rightAnswer: "C",
        explanation:
          "main.institute.article_4.questions.question_5.explanation",
      },
      {
        id: 6,
        text: "main.institute.article_4.questions.question_6.text",
        answerA: "main.institute.article_4.questions.question_6.answerA",
        answerB: "main.institute.article_4.questions.question_6.answerB",
        answerC: "main.institute.article_4.questions.question_6.answerC",
        answerD: "main.institute.article_4.questions.question_6.answerD",
        rightAnswer: "B",
        explanation:
          "main.institute.article_4.questions.question_6.explanation",
      },
    ]
  },
  {
    id: 5,
    title: "main.institute.article_5.title",
    desc: "main.institute.article_5.desc",
    name: "howToPromoteProducts",
    revision: "v1",
    navigation: [
      {
        label: "main.institute.article_5.navigation.pricing_policy.main",
        anchor: "#pricing_policy",
        children: [
          {
            label:
              "main.institute.article_5.navigation.pricing_policy.pricing_policy_requirements",
            anchor: "#pricing_policy_requirements",
          },
          {
            label:
              "main.institute.article_5.navigation.pricing_policy.pricing_policy__value",
            anchor: "#pricing_policy__value",
          },
          {
            label:
              "main.institute.article_5.navigation.pricing_policy.pricing_policy_dumping_proof",
            anchor: "#pricing_policy_dumping_proof",
          },
          {
            label:
              "main.institute.article_5.navigation.pricing_policy.pricing_policy_subagent_responsibility",
            anchor: "#pricing_policy_subagent_responsibility",
          },
          {
            label:
              "main.institute.article_5.navigation.pricing_policy.pricing_policy_penalty_procedure",
            anchor: "#pricing_policy_penalty_procedure",
          },
          {
            label:
              "main.institute.article_5.navigation.pricing_policy.pricing_policy_nda_agreement",
            anchor: "#pricing_policy_nda_agreement",
          },
        ],
      },
      {
        label: "main.institute.article_5.navigation.security_guidelines",
        anchor: "#security_guidelines",
      },
      {
        label: "main.institute.article_5.navigation.product_compliance",
        anchor: "#product_compliance",
      },
      {
        label: "main.institute.questions_navigation",
        anchor: "#questions",
      },
    ],
    questions: [
      {
        id: 0,
        text: "main.institute.article_5.questions.question_0.text",
        answerA: "main.institute.article_5.questions.question_0.answerA",
        answerB: "main.institute.article_5.questions.question_0.answerB",
        answerC: "main.institute.article_5.questions.question_0.answerC",
        answerD: "main.institute.article_5.questions.question_0.answerD",
        rightAnswer: "C",
        explanation:
          "main.institute.article_5.questions.question_0.explanation",
      },
      {
        id: 1,
        text: "main.institute.article_5.questions.question_1.text",
        answerA: "main.institute.article_5.questions.question_1.answerA",
        answerB: "main.institute.article_5.questions.question_1.answerB",
        answerC: "main.institute.article_5.questions.question_1.answerC",
        answerD: "main.institute.article_5.questions.question_1.answerD",
        rightAnswer: "C",
        explanation:
          "main.institute.article_5.questions.question_1.explanation",
      },
      {
        id: 2,
        text: "main.institute.article_5.questions.question_2.text",
        answerA: "main.institute.article_5.questions.question_2.answerA",
        answerB: "main.institute.article_5.questions.question_2.answerB",
        answerC: "main.institute.article_5.questions.question_2.answerC",
        answerD: "main.institute.article_5.questions.question_2.answerD",
        rightAnswer: "C",
        explanation:
          "main.institute.article_5.questions.question_2.explanation",
      },
      {
        id: 3,
        text: "main.institute.article_5.questions.question_3.text",
        answerA: "main.institute.article_5.questions.question_3.answerA",
        answerB: "main.institute.article_5.questions.question_3.answerB",
        answerC: "main.institute.article_5.questions.question_3.answerC",
        answerD: "main.institute.article_5.questions.question_3.answerD",
        rightAnswer: "A",
        explanation:
          "main.institute.article_5.questions.question_3.explanation",
      },
    ]
  },
  {
    id: 6,
    title: "main.institute.article_6.title",
    desc: "main.institute.article_6.desc",
    name: "marketingMaterials",
    revision: "v1",
    navigation: [
      {
        label: "main.institute.article_6.navigation.nzt_advantages",
        anchor: "#nzt_advantages",
      },
      {
        label: "main.institute.article_6.navigation.client_presentation_guide",
        anchor: "#client_presentation_guide",
      },
      {
        label: "main.institute.article_6.navigation.presentation_content_brief",
        anchor: "#presentation_content_brief",
      },
    ],
  },
  {
    id: 7,
    title: "main.institute.article_7.title",
    desc: "main.institute.article_7.desc",
    name: "generalRecommendations",
    navigation: [
      {
        label: "main.institute.article_7.navigation.client_communication",
        anchor: "#client_communication",
      },
      {
        label: "main.institute.article_7.navigation.marketing_materials",
        anchor: "#marketing_materials",
      },
      {
        label: "main.institute.article_7.navigation.ethics_compliance",
        anchor: "#ethics_compliance",
      },
      {
        label: "main.institute.article_7.navigation.first_contact_script",
        anchor: "#first_contact_script",
      },
      {
        label: "main.institute.article_7.navigation.common_mistakes",
        anchor: "#common_mistakes",
      },
    ],
  },
];
